var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-navbar", { attrs: { toggleable: "md" } }, [
    _c(
      "div",
      { staticClass: "mx-auto d-sm-flex d-block flex-sm-nowrap" },
      [
        _c("b-navbar-toggle", { attrs: { target: "nav_collapse_guardian" } }),
        _vm._v(" "),
        _c(
          "b-collapse",
          {
            staticClass: "text-center collapse navbar-collapse",
            attrs: { "is-nav": "", id: "nav_collapse_guardian" }
          },
          [
            _c(
              "b-navbar-nav",
              [
                _c("b-nav-item", { attrs: { to: "/guardians/guardians" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.guardians.guardians")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/guardians/proteges" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.guardians.proteges")) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("b-nav-item", { attrs: { to: "/guardians/invitations" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("menu.items.guardians.invitations")) +
                      "\n                "
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8fb5f80c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb5f80c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/GuardiansMenuComponent.vue
// module id = null
// module chunks = 